export const VuetifyMoneyOptions = {
  locale: 'en-US',
  prefix: '$',
  suffix: '',
  length: 13,
  precision: 2
};
export const CREATE_FORM_SUBTITLE =
  'Populate the input field(s) below to create a new record.';
export const UPDATE_FORM_SUBTITLE = 'Update the value(s) below and save.';
export const MEMBER_CATEGORIES = ['Staff', 'Member', 'Non-Member', 'Youth', 'Volunteer'];
